import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Finds the precomputed MoBI PWRSR PNG overlay + geographic bounds for a
 * given (mill, drive_time). The hook only fetches the small `.meta.json`
 * sidecar; Leaflet's ImageOverlay loads the PNG bytes itself when rendered.
 */
export const useImperiledSpeciesOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.mobiOverlayMeta,
  pngPath: API_CONFIG.s3.paths.mobiOverlay,
});
